import React from 'react';

export const PowerBIIconBorderless = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.4031 0H9.16178C8.7971 0 8.50146 0.295634 8.50146 0.660317V15.3397C8.50146 15.7044 8.7971 16 9.16178 16H13.4031C13.7677 16 14.0634 15.7044 14.0634 15.3397V0.660317C14.0634 0.295634 13.7677 0 13.4031 0Z"
			fill="#B25400"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.787 15.3395V15.9998H5.88542C5.52072 15.9998 5.2251 15.7042 5.2251 15.3395V4.64744C5.2251 4.28274 5.52072 3.98712 5.88542 3.98712H10.1267C10.4914 3.98712 10.787 4.28274 10.787 4.64744V15.3395Z"
			fill="#DE9800"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.787 15.3395V15.9998H5.88542C5.52072 15.9998 5.2251 15.7042 5.2251 15.3395V4.64744C5.2251 4.28274 5.52072 3.98712 5.88542 3.98712H10.1267C10.4914 3.98712 10.787 4.28274 10.787 4.64744V15.3395Z"
			fill="#DE9800"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.5619 15.3396V15.9999H2.66032C2.29562 15.9999 2 15.7043 2 15.3396V8.6602C2 8.2955 2.29562 7.99988 2.66032 7.99988H6.90159C7.26629 7.99988 7.5619 8.2955 7.5619 8.6602V15.3396Z"
			fill="#F3CD32"
		/>
	</svg>
);
